module.exports = __webpack_public_path__ + "5c114213/img/archive-icon.0a6a9de3.svg";